import { CmsImage, CmsLinkComponent, useLogger } from '@omnia/ui/src/lib'
import { Icon } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import type { CardGridGenericPropsApi } from '../models'

export const GenericCard: FC<CardGridGenericPropsApi> = card => {
    const logger = useLogger(['CardGrid', 'GenericCard'])

    logger.trace('Rendering', { card })

    const { image, link, title, description, descriptionColour, nearestStationName, nearestStationType } = card

    return (
        <CmsLinkComponent className="card-grid__card" link={link}>
            <CmsImage image={image} className="card__image" />
            <div className="card__details">
                {title && <h3 className="card__name">{title}</h3>}
                {description && (
                    <span className="card__description" style={{ color: `#${descriptionColour?.color}` }}>
                        {description}
                    </span>
                )}
                {nearestStationName && (
                    <span className="card__station">
                        <Icon name={nearestStationType || 'national-rail'} />
                        {nearestStationName}
                    </span>
                )}
            </div>
        </CmsLinkComponent>
    )
}
